<template>
	<b-card>
		<div slot="header" class="d-flex justify-content-between custom-card-header">
			<span class="card-header-title">{{ $t('sidebar.warehouse-management.expiredItems') }}</span>
		</div>
		<b-row style="padding: 10px">
			<b-col>
				<b-form-group
					size="sm"
					label-cols="3"
					label-for="refName"
				>
					<template slot="label">
						{{ $t('goods.create.select-group') }}:
					</template>
					<multiselect
						v-model="subCategoryId"
						:options="subCategory_s"
						label="name"
						track-by="id"
						size="sm"
						@remove="search.subCategoryId = null"
						@select="selectedGroup"
						:show-labels="false"
						:allow-empty="true"
						:placeholder="$t('goods.create.select-group')"
						class="multiselect-pricing"
					></multiselect>
				</b-form-group>
			</b-col>
			<b-col>
				<b-form-group
					size="sm"
					label-cols="3"
					label-for="refName"
				>
					<template slot="label">
						{{ $t('goods.create.category') }}:
					</template>
					<multiselect
						v-model="subCategory1Id"
						:options="subCategory1_s"
						:disabled="!subCategoryId"
						label="name"
						track-by="id"
						@remove="search.sub2CategoryId = null"
						@select="selectedCategory"
						:show-labels="false"
						:allow-empty="true"
						:placeholder="$t('goods.create.category')"
						class="multiselect-pricing"
					></multiselect>
				</b-form-group>
			</b-col>
			<b-col>
				<b-form-group
					size="sm"
					label-cols="4"
					label-for="refName"
				>
					<template slot="label">
						{{ $t('goods.create.select-subcategory') }}:
					</template>
					<multiselect
						v-model="subCategory2Id"
						:options="subCategory2_s"
						:disabled="!subCategory1Id"
						label="name"
						track-by="id"
						@remove="search.sub3CategoryId = null"
						@select="selectedSubCategory"
						:show-labels="false"
						:allow-empty="true"
						:placeholder="$t('goods.create.select-subcategory')"
						class="multiselect-pricing"
					></multiselect>
				</b-form-group>
			</b-col>
		</b-row>
		<b-row style="padding: 10px">
			<b-col cols="5">
				<b-input-group size="sm">
					<b-input-group-prepend class="align-items-center mr-2">
						{{ $t('certificate.expirationDate') }} :
					</b-input-group-prepend>
					<b-input v-model="search.day" type="number" :min="0"/>
				</b-input-group>
			</b-col>
		</b-row>
		<b-row style="padding: 20px; margin-bottom: 10px">
			<b-col>
				<multiselect
					v-model="depId"
					:options="departments"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					:multiple="false"
					label="name"
					size="sm"
					:placeholder="$t('incomeFilter.department')"
				/>
			</b-col>
			<b-col>
				<b-input-group>
					<b-input v-model="search.value" placeholder="search"></b-input>
					<b-input-group-append class="ml-3">
						<b-button variant="dark" class="fa fa-search" @click="getItems"/>
					</b-input-group-append>
				</b-input-group>
			</b-col>
			<b-col align="right">
				<b-button variant="danger" class="ml-3" @click="writeOffSelectionItems">{{ $t('spisat.title') }}</b-button>
			</b-col>
		</b-row>
		<div class="mb-2">
			<b-btn size="sm" variant="success" class="fa fa-check" @click="selectAllRows"/>
			<b-btn size="sm" variant="danger" class="fa fa-minus ml-2" @click="clearSelectedRows"/>
			<b-btn variant="primary" class="fa fa-shopping-cart ml-5" @click="viewSelectedItems = true">
				{{ selectedItems.length }}
			</b-btn>
		</div>
		<b-table
			:items="items"
			:fields="fieldsTable"
			bordered
			show-empty
			hover
			striped
			responsive
			selectable
			:per-page="0"
			selected-variant="danger"
			select-mode="multi"
			ref="selectableTable"
			@row-selected="onRowSelected"
		>
			<template slot="selected" slot-scope="{ rowSelected }">
				<template v-if="rowSelected">
					<span aria-hidden="true">&check;</span>
					<span class="sr-only">Selected</span>
				</template>
				<template v-else>
					<span aria-hidden="true">&nbsp;</span>
					<span class="sr-only">Not selected</span>
				</template>
			</template>
			<template slot="index" slot-scope="data">
				{{ data.index + 1 }}
			</template>
			<template slot="multiBarcode" slot-scope="data">
				<h6>
					<b-badge v-for="barcode in data.item.multiBarcode" class="ml-2">{{ barcode }}</b-badge>
				</h6>
			</template>
			<template slot="remaining" slot-scope="data">
				{{ data.item.remaining }} {{ data.item.unitName }}
			</template>
			<template slot="count" slot-scope="data">
				<b-input-group size="sm" style="width: 150px">
					<b-input v-model="data.item.count"/>
					<b-input-group-append>
						<b-button disabled>{{ data.item.unitName }}</b-button>
					</b-input-group-append>
				</b-input-group>
			</template>
		</b-table>
		<b-modal
			v-model="viewSelectedItems"
			size="xl"
			hide-footer
			:title="`Выбранные ${this.$t('incomes.create.products-items')}`"
			centered
		>
			<b-table
				:items="selectedItems"
				:fields="fields"
			>
				<template slot="index" slot-scope="data">
					{{ data.index + 1 }}
				</template>
				<template slot="multiBarcode" slot-scope="data">
					<h6>
						<b-badge v-for="barcode in data.item.multiBarcode" class="ml-2">{{ barcode }}</b-badge>
					</h6>
				</template>
				<template slot="remaining" slot-scope="data">
					{{ data.item.remaining }} {{ data.item.unitName }}
				</template>
				<template slot="count" slot-scope="data">
					<b-input-group size="sm">
						<b-input v-model="data.item.count"/>
						<b-input-group-append>
							<b-button disabled>{{ data.item.unitName }}</b-button>
						</b-input-group-append>
					</b-input-group>
				</template>
			</b-table>
		</b-modal>
	</b-card>
</template>

<script>
import UsersService from "../../../services/users.sevice";
import Multiselect from 'vue-multiselect'
import ClientService from "../../../services/client.service";
import ReferencesService from "../../../services/references.sevice";
import ExpiredItems from "./expired-items.service";

export default {
	name: "index",
	data() {
		return {
			depId: null,
			toExpiredDay: null,
			departments: [],
			subCategory_s: [],
			subCategoryId: null,
			subCategory1_s: [],
			subCategory1Id: null,
			subCategory2_s: [],
			subCategory2Id: null,
			selectedItems: [],
			items: [],
			viewSelectedItems: false,
			search: {
				day: null,
				subCategoryId: null,
				sub2CategoryId: null,
				sub3CategoryId: null,
				value: '',
				depIds: []
			},
			fields: [
				{key: 'index', label: '№', class: 'text-center'},
				{key: 'itemName', label: this.$t('pos.product')},
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center'},
				{key: 'multiBarcode', label: this.$t('goods.barcode'), class: 'text-center'},
				{key: 'regNumber', label: this.$t('pricing.costNumber'), class: 'text-center'},
				{key: 'termOfItem', label: this.$t('kirim.expirationDate'), class: 'text-center'},
				{key: 'departmentName', label: this.$t('incomes.department'), class: 'text-center'},
				{key: 'remaining', label: 'Oсталось', class: 'text-center'},
				{key: 'count', label: this.$t('sale.kol-vo'), class: 'text-center'},
				{key: 'priceUzs', label: this.$t('incomes.create.price'), class: 'text-center'}
			],
			fieldsTable: [
				{key: 'selected', label: '#', class: 'text-center'},
				{key: 'index', label: '№', class: 'text-center'},
				{key: 'itemName', label: this.$t('pos.product')},
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center'},
				{key: 'multiBarcode', label: this.$t('goods.barcode'), class: 'text-center'},
				{key: 'regNumber', label: this.$t('pricing.costNumber'), class: 'text-center'},
				{key: 'termOfItem', label: this.$t('kirim.expirationDate'), class: 'text-center'},
				{key: 'departmentName', label: this.$t('incomes.department'), class: 'text-center'},
				{key: 'remaining', label: 'Oсталось', class: 'text-center'},
				{key: 'count', label: this.$t('sale.kol-vo'), class: 'text-center width15'},
				{key: 'priceUzs', label: this.$t('incomes.create.price'), class: 'text-center'}
			]
		}
	},
	components: {Multiselect},
	computed: {},
	watch: {
		'depId': {
			handler(event) {
				this.search.depIds = []
				this.search.depIds.push(event.id)
				// event.forEach(d => {
				// 	if (d.id) {
				// 		this.search.depIds.push(d.id)
				// 	}
				// })
			}
		}
	},
	methods: {
		selectAllRows() {
			this.$refs.selectableTable.selectedRows = this.$refs.selectableTable.items
		},
		clearSelectedRows() {
			this.$refs.selectableTable.clearSelected()
		},
		onRowSelected(items) {
			this.selectedItems = items
		},
		getItems() {
			ClientService.getExpiredItems(this.search).then(res => {
				this.items = res.data
				this.items.forEach(item => {
					item.count = item.remaining
				})
			})
		},
		selectedGroup($event) {
			this.subCategory1Id = null
			this.subCategory2Id = null
			this.search.sub2CategoryId = null
			this.search.sub3CategoryId = null
			this.search.subCategoryId = $event.id
			ReferencesService.getSubReferenceChildren($event.id).then(res => {
				this.subCategory1_s = res.data
			})
		},
		selectedCategory($event) {
			this.subCategory2Id = null
			this.search.sub3CategoryId = null
			this.search.sub2CategoryId = $event.id
			ReferencesService.getSubReferenceChildren($event.id).then(res => {
				this.subCategory2_s = res.data
			})
		},
		selectedSubCategory($event) {
			this.search.sub3CategoryId = $event.id
		},
		writeOffSelectionItems() {
			if (this.selectedItems.length > 0) {
				this.$bvModal.msgBoxConfirm(this.$t('actions.deletetitle'), {
					hideHeader: true,
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: this.$t('actions.yes'),
					cancelTitle: this.$t('actions.no'),
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(value => {
					if (value) {
						ExpiredItems.writeOffSelectedItems(this.selectedItems).then(res => {
							this.search.day = null
							this.search.subCategoryId = null
							this.search.sub2CategoryId = null
							this.search.sub3CategoryId = null
							this.search.depIds = []
							this.search.value = ''
							this.getItems()
							this.$router.push(`/warehouse-management/writeOff/view/${res.data}`)
						}).catch(e => {
							console.log(e)
						})
					}
				})
			} else {
				this.$vs.notify({
					text: 'Пожалуйста, выберите товар',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		}
	},
	created() {
		ReferencesService.getSubReferenceChildren(14).then(response => {
			this.subCategory_s = response.data;
		})
		UsersService.getPermittedDepartments().then(res => {
			this.departments = res.data.permittedDepartments
		})
		this.getItems();
	}
}
</script>

<style scoped lang="css">
.width15 {
	max-width: 15px !important;
}
</style>
